import { authConstants } from '../_constants';

const errors = { non_field_errors: [] };
const initialState = {
  errors,
  whoami: { 'channels': [] }
};

const getChannel = (channels) => {
  const channelId = localStorage.getItem('channel')
  let channel = channels[0];
  if (channelId) {
    const index = channels.findIndex(ch => ch.id == channelId);
    channel = index > -1 ? channels[index] : channels[0];
  }
  return channel;
}

export function authentication(state = initialState, action) {
  switch (action.type) {
  case authConstants.LOGIN_REQUEST:
    return {
      ...state,
      loggingIn: true,
      user: action.user,
      errors
    };
  case authConstants.LOGIN_SUCCESS:
    localStorage.setItem('user', action.data.token);
    return {
      ...state,
      loggedIn: true,
      user: action.user,
      errors
    };
  case authConstants.LOGIN_FAILURE:
    return {
      ...state,
      errors: action.errors
    };
  case authConstants.WHO_AM_I_LOADED:
    return {
      ...state,
      whoami: action.data,
      channel: getChannel(action.data.channels)
    };
  case authConstants.SET_CHANNEL:
    const ch = state.whoami.channels.find(channel => channel.id == action.data)
    return {
      ...state,
      channel: ch
    };
  case authConstants.LOGOUT:
    return {};
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/authentication.reducer.js